import { Instance as axios, setHeaderWithImage, setToken } from "../instance";

// Download the user bulk-order sample sheet (Lpid/ServiceId/RateType/UserEmail
// are derived on the backend from the logged-in user + assigned vendor).
export const downloadBulkOrderSampleAPI = async () => {
  return axios.get(`api/user/bulk/order/sample`, {
    ...setToken(),
    responseType: "blob", // important: get the response as a blob
  });
};

// Upload the filled user bulk-order sheet to create orders.
export const uploadBulkOrderAPI = async (data) => {
  return axios.post(`api/user/bulk/order/create`, data, setHeaderWithImage());
};
